import { getCss, buildResponsiveStyles, mergeDeep } from '../../utils';
import {
  TFlexDirection,
  FlexDirectionType,
  TFlexWrap,
  FlexWrapType,
  TFlexGutterSize,
  FlexGutterSizeType,
  TFlexAlignContent,
  TFlexAlignItem,
  TFlexJustifyContent,
  FlexAlignContentType,
  FlexAlignItemType,
  TFlexInline,
  FlexInlineType,
} from './flex-utils';

export const createStyles = (
  inline: TFlexInline,
  direction: TFlexDirection,
  wrap: TFlexWrap,
  gutter: TFlexGutterSize,
  alignContent: TFlexAlignContent,
  alignItems: TFlexAlignItem,
  justifyContent: TFlexJustifyContent
): string => {
  return getCss({
    '@global': {
      ':host': mergeDeep(
        buildResponsiveStyles(inline, (inlineResponsive: FlexInlineType) => ({
          display: inlineResponsive ? 'inline-flex' : 'flex',
        })),
        buildResponsiveStyles(direction, (flexDirectionResponsive: FlexDirectionType) => ({
          flexDirection: flexDirectionResponsive,
        })),
        buildResponsiveStyles(wrap, (flexWrapResponsive: FlexWrapType) => ({
          flexWrap: flexWrapResponsive,
        })),
        buildResponsiveStyles(gutter, (gutterResponsive: FlexGutterSizeType) => ({
          gap: `${gutterResponsive}px`,
        })),
        buildResponsiveStyles(alignContent, (alignContentResponsive: FlexAlignContentType) => ({
          alignContent: alignContentResponsive,
        })),
        buildResponsiveStyles(alignItems, (alignItemsResponsive: FlexAlignItemType) => ({
          alignItems: alignItemsResponsive,
        })),
        buildResponsiveStyles(justifyContent, (justifyContentResponsive: FlexAlignContentType) => ({
          justifyContent: justifyContentResponsive,
        }))
      ),
    },
  });
};
